var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"mainCard",style:({ 'border-radius': `${_vm.radiusCard}px` })},[_vm._t("wrapper"),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }